import React from 'react'
import { connect } from 'react-redux'
import DeleteAddressModal from './DeleteAddressModal'
import { useParams } from 'react-router-dom'

function DeleteAddressModalContainer(props: any) {
  const { addressId, addressName } = useParams()

  function handleClose() {
    props.history.push(`/manage-address`)
  }
  return <DeleteAddressModal {...props} addressId={addressId} addressName={addressName} onClose={handleClose} />
}
export default connect()(DeleteAddressModalContainer)

